import { render, staticRenderFns } from "./SettingsTabPanel.vue?vue&type=template&id=4f604b13&scoped=true"
import script from "./SettingsTabPanel.vue?vue&type=script&lang=js"
export * from "./SettingsTabPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingsTabPanel.vue?vue&type=style&index=0&id=4f604b13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f604b13",
  null
  
)

export default component.exports